/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-15 17:38:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-05-11 22:05:55
 * @FilePath: \baishu_react_ui\src\Login\BsyRadioGroup\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { BsyUtils } from '../../utils/Utils';
import BsyRadioGroup from '../BsyRadioGroup';
import BsyTextTag from '../BsyTextTag';
import './index.css'
import BsySubformBase from '../BsySubformBase';

class BsySubformRadioGroup extends BsySubformBase {

    static defaultProps = {
        baseCls: "bsy-subform-x-group",

    }

    constructor(props) {
        super(props);
 
        let obj = this.getDefaultValue();
        this.state = {
            ...props,
            ...obj
        }
    }

    getValue = () => {
        // const { value } = this.state
        return this.value;
    }

    rebuild = () => {
        console.log('--- subform radiogroup rebuild bsy-ui-hidden ---');
        this.options.cssName = this.options.baseCls + ' ' + this.options.widgetName;
        if (!this.isEnabled()) {
            this.options.cssName += " bsy-ui-disable";
          }
          if (!this.isVisible()) {
            this.options.cssName += " bsy-ui-hidden";
          }

        if (this.options.customCls) {
            this.options.cssName += ' ' + this.options.customCls;
        }

        this.options.css = {}
        if (this.options.height)
            this.options.css.height = this.options.height;
        if (this.options.width)
            this.options.css.width = this.options.width;
        // this.options.css.lineHeight = this.options.lineHeight + 'px';
        this.value = this.options.value;
        let obj = this.getDefaultValue();
        this.setState(obj); 
    }

 
    popUpPaneClose = (e) => {

        if(e && e.target.classList.contains('icon-dingding-guide-close')) {
            this.value = '';
            this.setState({
                value: this.value,
            }, () => {
                BsyUtils.applyFunc(this, this.props.onStopEdit, [this.value, null, this], !1)
            })
            return !1;
        }

        if (!this.isEditd) {
            BsyUtils.applyFunc(this, this.props.onClose, [this.value, null, this], !1)
        } else {
            this.setState({
                value: this.value,
            }, () => {
                BsyUtils.applyFunc(this, this.props.onStopEdit, [this.value, null, this], !1)
            })
        }

        return !1;
    }

    clear = (event) => {
        event.stopPropagation();
        event.preventDefault();
        this.value = '';
        this.setState({
            value: '',
        }, () => {
            this.props.onStopEdit(this.state.value, null, this)
        })
    }

    popUpPane = () => {
        const { items } = this.options;
        const { value } = this.state;
        let that = this;
        this.popRef = React.createRef();
        that.isEditd = false;
        return <BsyRadioGroup
            colorEnable={this.props.colorEnable}
            ref={this.popRef}
            items={items}
            value={value}
            onAfterEdit={(e, item) => {
                that.isEditd = e !== that.state.value;
                that.value = e;
            }}
            onStopEdit={(e, item) => {

                that.isEditd = e !== that.state.value;
                that.value = e;
                // that.setState({
                //     value: e,
                // }, () => {

                if (!item.hasOwnProperty('isOther')) {
                    if (that.bubble) {
                        that.bubble.closeAlter();
                        // BsyUtils.applyFunc(that, that.props.onStopEdit, [e, null, that], !1)
                    }
                }
                // })

            }}
        ></BsyRadioGroup>
    }


    renderItem = () => {
        const { items, value } = this.state;

        if (!value) {
            return '';
        }

        if (!this.props.colorEnable) {
            return <span className="select-val">{value}</span>
        } else {
            let item = { text: value, value: value };
            items.map((a) => {
                if (a.value == value) {
                    item = { ...a }
                }
            })
            if (!item.color) {

                return <span className="bsy-text-tag  middle single-line"
                    style={{ color: "#333", background: "#f5f6f7" }}
                >{value}</span>

            }
            return <BsyTextTag
                customCls={" middle single-line"}
                text={item.text}
                color={item.color}
            > </BsyTextTag>
        }

    }

    renderDisablePane = () => {
        const { items, value } = this.state;

        if (BsyUtils.isObjectEmpty(value)) {
            return <div className={"bsy_form_item_disable "} data-watermark={React.language('content.empty')}></div>
        }

        if (!this.props.colorEnable) {

            return <div className={"bsy_form_item_disable "} data-watermark={React.language('content.empty')} title={value} >{value}</div>
        }

        let item = { text: value, value: value };
        items.map((a) => {
            if (a.value == value) {
                item = { ...a }
            }
        })
        if (!item.color) {
            return <div className={"bsy_form_item_disable "} data-watermark={React.language('content.empty')} ><span className="bsy-text-tag  middle single-line"
                style={{ color: "#333", background: "#f5f6f7" }}
            >{value}</span></div>
        }
        return <div className={"bsy_form_item_disable "} data-watermark={React.language('content.empty')} ><BsyTextTag
            customCls={" middle single-line"}
            text={item.text}
            color={item.color}
        > </BsyTextTag></div>

    }

    render() {
        const { items, value } = this.state
        const { cssName } = this.options
        let css = {
            width: this.options.width,
            height: this.options.height,
        }

        if (!this.isEnabled()) {
            return this.renderDisablePane()
        }

        return (
            <div className={cssName}
                style={css}
                ref={this.element}
                onClick={(e) => {
                    this._onTriggerClick(e, 'auto')
                }}
            >
                <div className="select-trigger">
                    {
                        this.renderItem()
                    }
                    {
                        this.renderBtn('icon-widget-radiogroup', value)
                    }
                </div>
            </div>
        );
    }
}

export default BsySubformRadioGroup;
